module.exports = __webpack_public_path__ + "static/purelogic-logo-ceb309b198b2539102d2aa8a1b22f0d1.jpeg";